import { CommonModule, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, input, Output } from '@angular/core';
import { GenericLinkDirective } from '@portal-front/portal-auth-in-memory-router';

@Component({
  standalone: true,
  selector: 'ef-create-account-features-banner',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, NgOptimizedImage, GenericLinkDirective],
  template: `
    <div
      class="md:w-full md:h-full bg-gray-10 text-gray-20 p-4 md:p-8 py-6 md:py-12 md:rounded-lg"
      [ngClass]="{ 'grid content-start gap-6 md:pt-36': !showRegistrationButton() }"
    >
      @if (showRegistrationButton()) {
        <h2 class="block text-heading-04 md:text-heading-03 text-black text-left" i18n>Dołącz do nas</h2>
        <button (click)="onRegisterClick()" class="block btn btn-primary btn-xl btn-outline w-full mt-6" i18n
          >Załóż nowe konto</button
        >
        <h6 class="text-black text-heading-06 my-8" i18n>Korzyści z posiadania konta w Empik Foto</h6>
      } @else {
        <h2 class="block text-heading-04 md:text-heading-03 text-black text-left" i18n>Z kontem zyskujesz więcej</h2>
      }

      <ul>
        @for (desc of featuresList; track desc) {
          <li class="flex content-center mb-4 last:mb-2">
            <img alt="lfeature icon" width="24" height="24" [ngSrc]="desc.icon" class="inline-block" />
            <span class="text-body-01 text-black ml-4">{{ desc.description }}</span>
          </li>
        }
      </ul>
    </div>
  `,
})
export class EfCreateAccountFeaturesBannerComponent {
  @Output() registerClick = new EventEmitter<void>();

  public readonly featuresList = [
    {
      icon: 'empikfoto/icons/list-bullets.svg',
      description: $localize`Historia i śledzenie zamówień`,
    },
    {
      icon: 'empikfoto/icons/picture.svg',
      description: $localize`Dostęp do projektów i zdjęć`,
    },
    {
      icon: 'empikfoto/icons/discount.svg',
      description: $localize`Korzystne rabaty i promocje`,
    },
    {
      icon: 'empikfoto/icons/star.svg',
      description: $localize`Specjalny rabat dla zarejestrowanych`,
    },
    {
      icon: 'empikfoto/icons/map-marker.svg',
      description: $localize`Darmowa dostawa od 89 zł`,
    },
  ];

  public onRegisterClick(): void {
    this.registerClick.emit();
  }

  public readonly showRegistrationButton = input<boolean>(true);
}
